import * as React from 'react';
import { SVGProps } from 'react';

const IconTeamSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13 7.5c0 2.232-1.199 4.5-3.5 4.5S6 9.732 6 7.5 6.028 3 9.5 3 13 5.268 13 7.5zM2 21c0-5.097 2.083-7 6.667-7h1.666C14.083 14 17 15.286 17 21H2zm11.756-9.273a5.847 5.847 0 0 1-.114.159A3.2 3.2 0 0 0 14.5 12c2.3 0 3.5-2.268 3.5-4.5S17.972 3 14.5 3c-.16 0-.314.005-.46.014.106.153.2.312.286.475.678 1.302.676 2.88.674 3.87V7.5c0 1.44-.38 2.983-1.244 4.227zM22 21h-3c0-3.028-.742-5.376-2.383-6.942C19.728 14.363 22 15.957 22 21z" />
  </svg>
);
export default IconTeamSizeM;
